import { render, staticRenderFns } from "./GoodsItemSingle.vue?vue&type=template&id=2f399770&scoped=true"
import script from "./GoodsItemSingle.vue?vue&type=script&lang=js"
export * from "./GoodsItemSingle.vue?vue&type=script&lang=js"
import style0 from "./GoodsItemSingle.vue?vue&type=style&index=0&id=2f399770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f399770",
  null
  
)

export default component.exports